var exports = {};

exports = (...arguments_) => {
  return [...new Set([].concat(...arguments_))];
};

export default exports;